import {
  SHOW_USER_DETAILS,
  HIDE_USER_DETAILS,
} from '../../constants/ActionTypes';

export function showUserDetails(userId) {
  return {
    type: SHOW_USER_DETAILS,
    result: { userId: userId },
  };
}

export function hideUserDetails() {
  return {
    type: HIDE_USER_DETAILS,
  };
}
